<template>
  <!-- z-index needed because of tab bar using z 100 -->
  <div class="pt-8 z-[101] relative flex gap-x-4">
    <multi-select
      v-model="value.licenseId"
      class="min-w-[20rem]"
      :searchable="true"
      :label="$t('licenses.license')"
      :placeholder="$t('licenses.license')"
      :options="fetchLicenses"
    />
    <multi-select
      v-model="value.boxType"
      :label="$t('licenses.boxType.DEFAULT')"
      :placeholder="$t('licenses.boxType.DEFAULT')"
      :options="fetchLicenseTypes"
    />
  </div>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { format } from 'date-fns';
import { useRoute } from 'vue-router';
import MultiSelect from '@/components/utils/Multiselect.vue';
import { collOptionsProvider, enumOptionsProvider } from '../table/hooks/provider';
import type { GlobalLicenseFilter } from './injects';
import type { License } from '@/entities/Entities';

interface Props {
  modelValue: GlobalLicenseFilter;
}

const emit = defineEmits(['update:modelValue']);
const props = defineProps<Props>();
const value = useVModel(props, 'modelValue', emit, { passive: true });

const { t } = useI18n();
const route = useRoute(); // Need to use the route to get company ID because syncHeader is bugged

const fetchLicenseTypes = enumOptionsProvider('/enums/LicenseType', (v) => ({
  value: v,
  label: t(`licenses.boxType.${v}`),
}));

const fetchLicenses = collOptionsProvider<License>(
  '/licenses',
  {
    filter: {
      company: `/companies/${route.params.companyId}`,
    },
    sort: {
      sortKey: 'startDate',
      sortDirection: 'DESC',
    },
  },
  (license: License) => ({
    // eslint-disable-next-line max-len
    label: `${license.startDate ? format(new Date(license.startDate), 'dd.MM.yyyy') : ''} - ${license.endDate ? format(new Date(license.endDate), 'dd.MM.yyyy') : ''}`,
    value: license['@id'],
  }),
);
</script>
